import React, { useMemo } from "react";
import { Button, Flex, Menu, notification, Select, Space, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "../../../node_modules/react-router-dom";
import ActiveIcon from "../../assets/icons/Active-sub-icon.svg";
import InActive from "../../assets/icons/inactive-sub-icon.svg";
import Sider from "antd/es/layout/Sider";
import LiveCallIcon from "../../assets/icons/live-calls.svg";
import SmsIcon from "../../assets/icons/sms.svg";
import ReportIcon from "../../assets/icons/reports.svg";
import ContactIcon from "../../assets/icons/Contacts.svg";
import HeaderLogo from "../../assets/icons/dataphone-header.svg";
import LogoMark from "../../assets/icons/Logomark Coloured.png";
import { usePermissions } from "../../hooks/permissions";
import { DropDownTitle } from "../Generic";
import styled from "styled-components";
import { LockOutlined } from "@ant-design/icons";
import { useCookies } from "react-cookie";
const FiltersWrapper = styled.div `
  position: absolute;
  bottom: 30px;
  z-index: 1;
  transition: all 0.2s;
  width: 100%;
  padding: 10px;
`;
const StyledSelect = styled(Select) `
  width: 100%;
  height: 55px;
  border: 1px solid rgba(176, 176, 176, 1);
  border-radius: 8px;

  .ant-menu-item-disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  
  &:hover {
    background-color: transparent !important;
  }
  
  .ant-menu-title-content {
    cursor: not-allowed !important;
    }
  }

  .ant-menu-item-disabled .ant-menu-item-icon {
  opacity: 0.5 !important;
  }

  .ant-select-selector {
    background: transparent !important;
  }

  .ant-select-selection-placeholder {
    color: white !important;
  }

  .ant-select-selection-search-input {
    color: white !important;
  }

  .ant-select-arrow {
    color: white !important;
  }

  .ant-select-clear {
    height: 18px !important;
    width: 18px !important;
  }

  .ant-select-clear > .anticon-close-circle svg {
    fill: black !important;
    height: 18px !important;
    width: 18px !important;
    border-radius: 50% !important;
    border: 1px solid white !important;
    background: white !important;
    box-sizing: border-box;
  }
`;
const DisabledMenuItemWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: white;
  
  .lock-icon {
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    margin-left: auto;
  }
`;
const MenuItemLabel = ({ permission, label }) => {
    return label;
};
const SubMenuItemLabel = ({ label, icon, enabled = false }) => {
    if (!enabled) {
        return;
    }
    if (enabled === true) {
        return React.createElement("span", { style: { color: 'white' } }, label);
    }
    const content = (React.createElement(DisabledMenuItemWrapper, null,
        React.createElement("span", null, label),
        React.createElement(LockOutlined, { className: "lock-icon" })));
    if (enabled === "locked-premium") {
        return (React.createElement(Tooltip, { title: "Premium Feature", placement: "right" }, content));
    }
    else if (enabled === "locked") {
        return content;
    }
};
export const SideBar = ({ appName, appMenu, permissions, accounts, userAccount, collapsed, setCollapsed, setSelectedAccountId, selectedAccountId, }) => {
    const [cookies, setCookie] = useCookies(["last_account_id"]);
    const { hasPermission } = usePermissions({ userPermissions: permissions });
    const navigate = useNavigate();
    const [active, setActive] = useState(appName);
    const [openKey, setOpenKey] = useState([appName]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const account_id = cookies.last_account_id || userAccount;
    const [firstLoad, setFirstLoad] = useState(true);
    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            return;
        }
        if (!cookies.last_account_id || !sessionStorage.getItem("account_id")) {
            return;
        }
        if (cookies.last_account_id !== sessionStorage.getItem("account_id")) {
            openNotificationChangeAccount(cookies.last_account_id);
        }
        else if (cookies.last_account_id === sessionStorage.getItem("account_id")) {
            notification.destroy();
        }
    }, [cookies.last_account_id, firstLoad]);
    const openNotificationChangeAccount = (accountId) => {
        const key = "account_change_notification";
        const accountName = accounts.find(acc => acc.id === accountId)?.name;
        const btn = (React.createElement(Space, null,
            React.createElement(Button, { type: "link", size: "small", onClick: () => {
                    notification.destroy(key);
                } }, "Dismiss"),
            React.createElement(Button, { type: "primary", size: "small", onClick: () => {
                    notification.destroy(key);
                    handleAccountChange(accountId);
                } }, "Switch")));
        notification.open({
            message: 'Account Change Detected',
            description: (React.createElement(React.Fragment, null,
                "Account changed to ",
                React.createElement("u", null, accountName),
                " on another tab. Do you want to switch to that account?")),
            btn,
            placement: "top",
            duration: 0,
            key,
            onClose: () => { },
        });
    };
    useEffect(() => {
        sessionStorage.setItem("account_id", account_id);
        setSelectedAccountId?.(account_id);
    }, []);
    const handleAccountChange = (value) => {
        setSelectedAccountId?.(value);
        sessionStorage.setItem("account_id", value);
        setCookie("last_account_id", value, { path: "/", domain: ".dataphone.cloud" });
    };
    useEffect(() => {
        const currentPath = window.location.pathname;
        const matchingSubItem = appMenu.find(item => item.path === currentPath);
        if (matchingSubItem) {
            setSelectedKeys([matchingSubItem.key]);
            setActive(matchingSubItem.key);
        }
        else {
            setSelectedKeys([appName]);
            setActive(appName);
        }
    }, [window.location.pathname, appMenu, appName]);
    const subMenu = appMenu.filter(item => item.enabled).map((item) => {
        const isDisabled = item.enabled !== true;
        const isActive = item.path === window.location.pathname;
        return {
            key: item.key,
            icon: isActive ? (React.createElement("img", { src: ActiveIcon, height: 22, width: 22, alt: "active" })) : (React.createElement("img", { src: InActive, height: 10, width: 0, alt: "inactive", style: { opacity: isDisabled ? 0.5 : 1 } })),
            label: (React.createElement(SubMenuItemLabel, { label: item.label, icon: item.icon, enabled: item.enabled })),
            className: `${isActive ? "ant-menu-item-selected" : ""} ${isDisabled ? "ant-menu-item-disabled" : ""}`,
            disabled: isDisabled,
            onClick: () => {
                if (isDisabled) {
                    return; // Prevent navigation if disabled
                }
                navigate(item.path);
            },
            style: {
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
            }
        };
    });
    const menu = [
        {
            key: "liveCalls",
            icon: (React.createElement("img", { color: active === "liveCalls" ? "black" : "white", src: LiveCallIcon, height: 22, width: 22, alt: "live-calls" })),
            label: React.createElement(MenuItemLabel, { permission: true, label: "Live Calls" }),
            onClick: () => {
                if (!hasPermission("web-applications", ["teledash:any"]) ||
                    !process.env.REACT_APP_LIVE_CALL_URL ||
                    appName === "liveCalls") {
                    return;
                }
                window.location.href = process.env.REACT_APP_LIVE_CALL_URL;
            },
        },
        {
            key: "sms",
            icon: (React.createElement("img", { color: active === "sms" ? "black" : "white", src: SmsIcon, height: 22, width: 22, alt: "sms" })),
            label: React.createElement(MenuItemLabel, { permission: true, label: "SMS" }),
            onClick: () => {
                if (!hasPermission("web-applications", ["sms:any"]) ||
                    !process.env.REACT_APP_SMS_URL ||
                    appName === "sms") {
                    return;
                }
                window.location.href = process.env.REACT_APP_SMS_URL;
            },
        },
        {
            key: "reports",
            icon: React.createElement("img", { src: ReportIcon, height: 22, width: 22, alt: "reports" }),
            label: React.createElement(MenuItemLabel, { permission: true, label: "Reports" }),
            onClick: () => {
                if (!process.env.REACT_APP_REPORTS_URL || appName === "reports") {
                    return;
                }
                window.location.href = process.env.REACT_APP_REPORTS_URL;
            },
        },
        {
            key: "contacts",
            icon: React.createElement("img", { src: ContactIcon, height: 22, width: 22, alt: "contacts" }),
            label: React.createElement(MenuItemLabel, { permission: true, label: "Contacts" }),
            onClick: () => {
                if (!process.env.REACT_APP_CONTACTS_URL || appName === "contacts") {
                    return;
                }
                window.location.href = process.env.REACT_APP_CONTACTS_URL;
            },
        },
    ].map((item) => {
        if (item.key === appName) {
            return {
                ...item,
                children: subMenu.map((subItem) => {
                    return {
                        ...subItem,
                    };
                }),
            };
        }
        return item;
    });
    const accountOptions = useMemo(() => {
        const parents = accounts.filter((a) => a.parent_id === null);
        return parents.map((parent) => {
            const subs = accounts.filter((a) => a.parent_id === parent.id);
            if (subs.length > 0) {
                return {
                    label: parent.name,
                    options: [
                        { value: parent.id, label: parent.name },
                        ...subs.map((sub) => ({ value: sub.id, label: sub.name })),
                    ],
                };
            }
            return { value: parent.id, label: parent.name };
        });
    }, [accounts]);
    const contentStyle = {
        height: "100%",
        borderRight: "1px solid rgb(223, 226, 232)",
    };
    return (React.createElement(Sider, { width: 260, style: contentStyle, collapsed: collapsed, collapsible: true, onCollapse: (collapsed) => setCollapsed(collapsed) },
        React.createElement("img", { style: { padding: "30px", width: "100%" }, src: collapsed ? LogoMark : HeaderLogo }),
        React.createElement(Menu
        // defaultOpenKeys={[appName]}
        , { 
            // defaultOpenKeys={[appName]}
            openKeys: openKey, onOpenChange: (openKeys) => setOpenKey(openKeys), mode: "inline", inlineCollapsed: collapsed, defaultSelectedKeys: [active], selectedKeys: selectedKeys, items: menu, theme: "dark" }),
        hasPermission("accounts", ["read:any", "read:subAccount"]) &&
            !collapsed && (React.createElement(FiltersWrapper, null,
            React.createElement(Flex, { vertical: true, gap: 10 }, hasPermission("accounts", ["read:any", "read:subAccount"]) && (React.createElement(StyledSelect, { placeholder: "Select Account", options: accountOptions, defaultValue: account_id, onChange: (val) => handleAccountChange(val), value: selectedAccountId || account_id, showSearch: true, filterOption: (input, opt) => (opt?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase()), labelRender: (value) => (React.createElement(DropDownTitle, { label: "Accounts", value: value.label || "Select Account" })) }))),
            "),"))));
};
